<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="this.suppliers_client_details" class="d-flex">
                            <button
                                v-if="findPermission('Add and Edit Suppliers') || isTypeUser"
                                @click="handleModal('addSuppliersModal')"
                                class="btn btn-primary btn-sm mt-2"
                            >
                                Add Suppliers
                            </button>
                            <div v-if="suppliersToDeleteIds.length > 0">
                                <button @click="handleDelete" class="btn btn-primary btn-sm mt-2 ml-2">
                                    Delete Suppliers
                                </button>
                            </div>
                            <div v-if="changed_rows.length > 0">
                                <button @click="saveTable" class="btn btn-primary btn-sm mt-2 ml-2">
                                    Save Changes
                                </button>
                                <button @click="cancelUpdate" class="btn btn-danger btn-sm mt-2 ml-2">
                                    Cancel Update
                                </button>
                            </div>
                        </div>

                        <div class="float-right mb-2" v-if="this.client_suppliers && this.client_suppliers.length > 0">
                            No. of Suppliers: {{ this.client_suppliers.length }}
                        </div>
                        <SuppliersTable @handleModal="handleModal" @handleChangedRow="handleChangedRow" />
                    </div>
                </div>
            </div>
        </div>

        <!-- reconfig modals -->
        <CertificateListModal v-if="showModal_certificateListModal" @handleModal="handleModal" />

        <CertificateEditModal v-if="showModal_certificateEditModal" @handleModal="handleModal" />

        <CertificateAddSearchModal v-if="showModal_certificateAddSearchModal" @handleModal="handleModal" />

        <CertificateMatchListModal v-if="showModal_certificateMatchListModal" @handleModal="handleModal" />

        <CertificateCheckModal v-if="showModal_certificateCheckModal" @handleModal="handleModal" />

        <DataQCModal v-if="showModal_DataQCModal" />

        <CertificateViewModal v-if="showModal_certificateViewModal" @handleModal="handleModal" />

        <CertificateAddModal v-if="showModal_certificateAddModal" @handleModal="handleModal" />

        <AffidavitValidationModal v-if="showModal_affidavitValidationModal" @handleModal="handleModal" @setModalFalse="setModalFalse" />

        <CertificateSharingModal v-if="showModal_certificateSharingModal" @handleModal="handleModal" />

        <CertificateAuthenticationModal v-if="showModal_certificateAuthenticationModal" @handleModal="handleModal" />

        <AddSuppliersModal v-if="showModal_addSuppliersModal" />
        <!-- TODO: These are still part of the code that needs to be refactored -->

        <hr />

        <!--
            ! Not quite sure where these modals fit into the system yet
            
            <ValidationQCModal v-if="showModal_validationQCModal" />
            <button @click="validationQCModal">Validation QC Modal</button>

            <AuthenticationQCModal v-if="showModal_authenticationQCModal" />
            <button @click="authenticationQCModal">Authentication QC Modal</button> 
        -->
    </div>
</template>

<script>
import Swal from "sweetalert2";
//eslint-disable-next-line
import { adminComputed, adminMethods, suppliersComputed, suppliersMethods } from "@/state/helpers";
import SuppliersTable from "./tables/suppliersTable.vue";

import ValidationQCModal from "../modals/validationQCModal.vue";

import AuthenticationQCModal from "../modals/authenticationQCModal.vue";

//reconfiged
import CertificateListModal from "../modals/certificateListModal.vue";

import CertificateEditModal from "../modals/certificateEditModal.vue";

import CertificateAddSearchModal from "../modals/certificateAddSearchModal.vue";

import CertificateMatchListModal from "../modals/certificateMatchListModal.vue";

import CertificateCheckModal from "../modals/certificateCheckModal.vue";

import DataQCModal from "../modals/dataQCModal.vue";

import CertificateViewModal from "../modals/certificateViewModal.vue";

import CertificateAddModal from "../modals/certificateAddModal.vue";

import AffidavitValidationModal from "../modals/affidavitValidationModal.vue";

import CertificateSharingModal from "../modals/certificateSharingModal.vue";

import CertificateAuthenticationModal from "../modals/certificateAuthenticationModal.vue";

import AddSuppliersModal from "../modals/addSuppliersModal.vue";

export default {
    components: {
        SuppliersTable,

        //eslint-disable-next-line
        ValidationQCModal,
        //eslint-disable-next-line
        AuthenticationQCModal,
        //reconfiged
        CertificateListModal,
        CertificateEditModal,
        CertificateAddSearchModal,
        CertificateMatchListModal,
        CertificateCheckModal,
        DataQCModal,
        CertificateViewModal,
        CertificateAddModal,
        AffidavitValidationModal,
        CertificateSharingModal,
        CertificateAuthenticationModal,
        AddSuppliersModal,
    },
    data: () => ({
        row_ids_to_update: [],
        changed_rows: [],
        validation_messages: [],
        showModal_validationQCModal: false,

        showModal_authenticationQCModal: false,
        //reconfiged
        showModal_certificateListModal: false,
        showModal_certificateEditModal: false,
        showModal_certificateAddSearchModal: false,
        showModal_certificateMatchListModal: false,
        showModal_certificateCheckModal: false,
        showModal_DataQCModal: false,
        showModal_certificateViewModal: false,
        showModal_certificateAddModal: false,
        showModal_affidavitValidationModal: false,
        showModal_certificateSharingModal: false,
        showModal_certificateAuthenticationModal: false,
        showModal_addSuppliersModal: false,
    }),
    computed: {
        ...adminComputed,
        ...suppliersComputed,
    },
    methods: {
        ...suppliersMethods,
        ...adminMethods,
        //reconfig
        setModalFalse(modelName) {
            if (modelName == "affidavitValidationModal") return (this.showModal_affidavitValidationModal = false);
        },
        //this method jsut sets the flags in data for visibility of the modals
        setModalFlag(modelName, flag) {
            // //eslint-disable-next-line
            // console.log("SET MODAL FLAG", modelName, flag);
            if (modelName == "certificateListModal") return (this.showModal_certificateListModal = flag);

            if (modelName == "certificateEditModal") return (this.showModal_certificateEditModal = flag);

            if (modelName == "certificateAddSearchModal") return (this.showModal_certificateAddSearchModal = flag);

            if (modelName == "certificateMatchListModal") return (this.showModal_certificateMatchListModal = flag);

            if (modelName == "certificateCheckModal") return (this.showModal_certificateCheckModal = flag);

            if (modelName == "dataQCModal") return (this.showModal_DataQCModal = flag);

            if (modelName == "certificateViewModal") return (this.showModal_certificateViewModal = flag);

            if (modelName == "certificateAddModal") return (this.showModal_certificateAddModal = flag);

            if (modelName == "affidavitValidationModal") return (this.showModal_affidavitValidationModal = flag);

            if (modelName == "certificateSharingModal") return (this.showModal_certificateSharingModal = flag);

            if (modelName == "certificateAuthenticationModal") return (this.showModal_certificateAuthenticationModal = flag);

            if (modelName == "addSuppliersModal") return (this.showModal_addSuppliersModal = flag);
        },

        //this method refreshes datatables, jsut add the desired datables name as a OR condition
        refreshDataTable(tableName) {
            if (tableName == "certificateListModal" || tableName == "certificateMatchListModal") {
                setTimeout(() => {
                    this.$nextTick(() => {
                        window.webix.$$(tableName + "Table").refresh();
                    });
                }, 50);
            }
        },

        // this method handles the displaying of modals
        handleModal(modalName) {
            //call the make the modals flag active
            this.setModalFlag(modalName, true);

            setTimeout(() => {
                this.$bvModal.show(`${modalName}`);
                //will refresh the datatable due to DOM render issues
                this.refreshDataTable(modalName);

                this.$root.$once("bv::modal::hide", (event) => {
                    if (event.type == "hide" && event.componentId == `${modalName}`) {
                        this.setModalFlag(modalName, false);
                    }
                });
            });
        },
        // TODO: all these modals will be one thing in future

        validationQCModal() {
            this.showModal_validationQCModal = true;
            this.$nextTick(() => {
                this.$bvModal.show("validationQCModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "validationQCModal") {
                        this.showModal_validationQCModal = false;
                    }
                });
            });
        },

        authenticationQCModal() {
            this.showModal_authenticationQCModal = true;
            this.$nextTick(() => {
                this.$bvModal.show("authenticationQCModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "authenticationQCModal") {
                        this.showModal_authenticationQCModal = false;
                    }
                });
            });
        },

        handleDelete() {
            Swal.fire({
                title: ` Are you sure you want to delete supplier/s `,
                text: ``,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.deleteClientSuppliers({ ids: this.suppliersToDeleteIds }).then(() => {
                        // this.formSubmit = false;
                        Swal.fire({ title: ``, text: "Suppliers Deleted", icon: "success" });
                        // this.$emit("handleModal", "certificateEditModal");
                        // this.$emit("handleModal", "certificateListModal");
                        this.setSuppliers(this.$route.params.client_id);
                    });
                }
            });
        },

        cancelUpdate() {
            if (this.changed_rows.length == 0) {
                return;
            }
            let table = window.webix.$$("suppliersTable");
            table.editStop();
            this.setSuppliers(this.$route.params.client_id);
            this.row_ids_to_update = [];
            this.changed_rows = [];
            this.validation_messages = [];
        },

        handleChangedRow(objToEmitted) {
            // Check if the object with the same 'id' already exists in the array
            const index = this.changed_rows.findIndex((item) => item.id === objToEmitted.id);

            if (index !== -1) {
                this.changed_rows.splice(index, 1, objToEmitted);
            } else {
                this.changed_rows.push(objToEmitted);
            }
            //run the validation now
            this.handleValidation();
        },

        handleValidation() {
            const validationErrors = [
                { field: "vat_no", length: 10, message: "<li>Vat Numbers must be 10 characters</li>" },
                { field: "company_reg", length: 14, message: "<li>Company Registration must be 14 characters</li>" },
                { field: "supplier_no", message: "<li>Supplier Number is required</li>" },
                { field: "supplier_name", message: "<li>Supplier Name is required</li>" },
                { field: "contact_no", message: "<li>Contact number required</li>" },
                { field: "contact_person", message: "<li>Contact Person Required</li>" },
                { field: "email", message: "<li>Email Required</li>" },
                { field: "address", message: "<li>Address Required</li>" },
            ];

            const totals = {};

            for (const error of validationErrors) {
                totals[error.field] = 0;

                for (const row of this.changed_rows) {
                    if (!row[error.field]) {
                        const index = this.validation_messages.indexOf(error.message);
                        if (index === -1) {
                            this.validation_messages.push(error.message);
                        }
                        totals[error.field]++;
                    }
                }

                if (totals[error.field] === 0) {
                    const index = this.validation_messages.indexOf(error.message);
                    if (index >= 0) {
                        this.validation_messages.splice(index, 1);
                    }
                }
            }

            // Additional logic for updating row_ids_to_update if there are no validation errors
            for (const row of this.changed_rows) {
                const hasNoErrors = validationErrors.every((error) => row[error.field]);

                if (hasNoErrors) {
                    const index = this.row_ids_to_update.indexOf(row.id);
                    if (index === -1) {
                        this.row_ids_to_update.push(row.id);
                    }
                }
            }
        },

        saveTable() {
            let all_data = [];
            let table = window.webix.$$("suppliersTable");
            // this.handleValdiation();

            if (this.validation_messages.length > 0) {
                let restructureMessage = "";

                // change array: validation_messages to string: restructureMessage
                for (let i = 0; i < this.validation_messages.length; i++) {
                    restructureMessage += this.validation_messages[i];
                }

                Swal.fire({
                    title: `Validation Failed`,
                    html: `<ul class='text-left text-nowrap'>` + restructureMessage + `</ul>`,
                    customClass: "swal-wide",
                    icon: "warning",
                    // timer: 5000,
                });
                
                return;
            }

            // table.editStop();

            let id = 0;
            for (let i = 0; i < this.row_ids_to_update.length; i++) {
                id = this.row_ids_to_update[i];
                all_data.push(table.getItem(id));
            }
            this.changes_made_flag = false;
            Swal.fire({
                title: ` Are you sure you want to update your suppliers? `,
                text: ``,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.updateClientSupplier({ suppliers: all_data }).then(() => {
                        Swal.fire({ title: ``, text: "Suppliers Updated", icon: "success" });
                        this.setSuppliers(this.$route.params.client_id);
                        this.cancelUpdate();
                        this.row_ids_to_update = [];
                    });
                }
            });
        },
    },

    mounted() {},
    beforeDestroy() {
        this.resetSuppliersToDeleteIds();
    },
};
</script>

<style lang="scss">
.swal-wide {
    width: 550px;
}
</style>
